"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpolateErrors = void 0;
exports.toBoolean = toBoolean;
exports.isPromise = isPromise;
exports.keepErrorSettingInSecret = keepErrorSettingInSecret;
const utils_1 = require("../../utils");
const i18n_1 = require("./i18n");
function toBoolean(value) {
    switch (typeof value) {
        case 'string':
            if (value === 'true' || value === '1') {
                return true;
            }
            else if (value === 'false' || value === '0') {
                return false;
            }
            else {
                throw `Cannot coerce string ${value} to boolean}`;
            }
        case 'boolean':
            return value;
        default:
            return !!value;
    }
}
function isPromise(value) {
    return (value &&
        value.then &&
        typeof value.then === 'function' &&
        Object.prototype.toString.call(value) === '[object Promise]');
}
function keepErrorSettingInSecret(rule, component) {
    var _a;
    return rule === 'custom' && !!((_a = component.validate) === null || _a === void 0 ? void 0 : _a.customPrivate);
}
const getCustomErrorMessage = ({ errorKeyOrMessage, context }) => { var _a, _b; return ((_b = (_a = context.component) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b[errorKeyOrMessage]) || ''; };
/**
 * Interpolates @formio/core errors so that they are compatible with the renderer
 * @param {FieldError[]} errors
 * @param firstPass
 * @returns {[]}
 */
const interpolateErrors = (errors, lang = 'en') => {
    return errors.map((error) => {
        const { errorKeyOrMessage, context } = error;
        const i18n = i18n_1.VALIDATION_ERRORS[lang] || {};
        const toInterpolate = getCustomErrorMessage(error) || i18n[errorKeyOrMessage] || errorKeyOrMessage;
        const paths = [];
        context.path.split('.').forEach((part) => {
            const match = part.match(/\[([0-9]+)\]$/);
            if (match) {
                paths.push(part.substring(0, match.index));
                paths.push(parseInt(match[1]));
            }
            else {
                paths.push(part);
            }
        });
        return {
            message: (0, utils_1.unescapeHTML)(utils_1.Evaluator.interpolateString(toInterpolate, context)),
            level: error.level,
            path: paths,
            context: {
                validator: error.ruleName,
                hasLabel: context.hasLabel,
                key: context.component.key,
                label: context.component.label || context.component.placeholder || context.component.key,
                path: context.path,
                value: context.value,
                setting: keepErrorSettingInSecret(error.ruleName, context.component) ? '' : context.setting,
                index: context.index || 0,
            },
        };
    });
};
exports.interpolateErrors = interpolateErrors;
